import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class ArtifactsArtifactViewRoute extends Route {
  model() {
    return this.modelFor('artifacts.artifact');
  }
}

export default instrumentRoutePerformance(ArtifactsArtifactViewRoute);
